import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { CodeState } from '@app/selectors/system/code.selector';
import { OrderSearchNotLoginState } from '@app/selectors/myoffice/order/order-search-not-login.selector';
import {
  searchOrderNotLogin,
  countOrderNotLogin,
  sumOrderNotLogin,
} from '@app/actions/myoffice/order/order-search-not-login.action';
import { environment } from 'src/environments/environment';
import { OverlayLoadingState } from '@app/selectors/overlay-loading.selector';
import { setShowOverlayLoading } from '@app/actions/overlay-loading.action';
import { ValidationUtil } from '@app/common/util/validation.util';

@Component({
  selector: 'order-search-filter-not-login',
  templateUrl: './order-search-filter-not-login.component.html',
  styleUrls: ['./../order-search-not-login.component.css'],
})
export class OrderSearchFilterNotLoginComponent implements OnInit, OnChanges {

  @Input()
  reload: boolean = false;

  @Input()
  page: number | String = 0;

  @Input()
  len: number | String = 10;

  @Input()
  rName: string = '';

  @Input()
  rMobile: string = '';

  @Output()
  openMemberPopup = new EventEmitter<boolean>();

  @Output()
  search = new EventEmitter<any>();

  constructor(
    private _codeStore: Store<CodeState>,
    private _orderSearchStore: Store<OrderSearchNotLoginState>,
    private _overlayLoadingStore: Store<OverlayLoadingState>
  ) {

  }

  ngOnInit(): void {
    
  }

  ngOnChanges(changes: SimpleChanges): void {
    let pageChangeEvent = changes['page'];
    let lenChangeEvent = changes['len'];
    let reloadChangeEvent = changes['reload'];

    if ((ValidationUtil.isNotNullAndNotEmpty(reloadChangeEvent) && this.reload) || ValidationUtil.isNotNullAndNotEmpty(lenChangeEvent)) {
        this.handleOnSearch();
    } else if (ValidationUtil.isNotNullAndNotEmpty(pageChangeEvent)) {
      this.handleChangePage();
    }
  }

  getParams(): any {
    let params = {
      comId: environment.comId,
      lang: environment.default_lang,
      rName: this.rName,
      rMobile: this.rMobile,
      page: Number(this.page) - 1,
      len: this.len,
    };
    
    return params;
  }

  handleOnSearch(): void {
    let params = this.getParams();

    this._overlayLoadingStore.dispatch(
      setShowOverlayLoading({ loading: true })
    );

    this._orderSearchStore.dispatch(searchOrderNotLogin({ params: params }));
    this._orderSearchStore.dispatch(countOrderNotLogin({ params: params }));
    this._orderSearchStore.dispatch(sumOrderNotLogin({ params: params }));
  }

  handleChangePage(): void {
    let params = this.getParams();

    this._overlayLoadingStore.dispatch(
      setShowOverlayLoading({ loading: true })
    );

    this._orderSearchStore.dispatch(searchOrderNotLogin({ params: params }));
  }
}
